// web-only
// export const clear = localStorage.clear.bind(localStorage)
export const getStored = (key: string) => localStorage.getItem(key)
export const removeStored = (key: string) => localStorage.removeItem(key)
export const setStored = (key: string, value: string) => localStorage.setItem(key, value)
